<template>
  <layout-main>
    <div class="home">
      <!-- Header -->
      <div class="subheader">
        <div class="subheader-main">
          <div class="subheader-left">
            <h3>
              Ingen åtkomst
            </h3>
            <span class="separator-line"></span>
            <div class="breadcrumbs">
              <router-link to="/" class="breadcrumbs-link"> Hem</router-link>
              <span class="separator-dot"></span>
              <router-link to="/" class="breadcrumbs-link"> Ingen åtkomst</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Header -->

      <div class="row">
        <div class="col-lg-12">Du har inte åtkomst till den här sidan.</div>
      </div>
    </div>
  </layout-main>
</template>

<script>
import LayoutMain from '@/views/Layouts/Main';

export default {
  name: '403',
  components: {
    LayoutMain,
  },
};
</script>
